import { render } from "./pane.vue?vue&type=template&id=7879bbaa"
import script from "./pane.vue?vue&type=script&lang=js"
export * from "./pane.vue?vue&type=script&lang=js"
script.render = render

export default script